/* eslint-disable no-underscore-dangle */
/* eslint-disable radix */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-console */
/* eslint-disable no-unreachable */
/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { FaLock } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { postSync } from '../../../../api/mutations';
import {
  getMyAccount, getMySongs, getSyncs, getUserMeta, getMyProfile,
} from '../../../../api/queries';
import ApiErrorMessage from '../../../../components/apiErrorMessage';
import ButtonInner from '../../../../components/buttonInner';
import ButtonIcon from '../../../../images/rebrandIcons/ButtonIcon.png';
import H2 from '../../../../components/h2';
import H4 from '../../../../components/h4';
import MultipleSelect from '../../../../components/multipleSelect';
import Select from '../../../../components/select';
import Spacer from '../../../../components/spacer';
import TextArea from '../../../../components/textArea';
import { sendEvent } from '../../../../helpers/helpers';
import AppState from '../../../../store/appstate';
import RebrandPrimaryButton from '../../../../components/rebrandPrimaryButton';
import useSyncsQuery from '../../../../api/sanity/queries/getSyncs';
import useSiteConfigAuth from '../../../../api/sanity/queries/getSiteConfigWithCode';

function SyncsApply(props) {
  const flags = useFlags();
  const reskinFlag = flags['publishing-dashboard-reskin'];
  const { t } = useTranslation('other');
  const { id } = useParams();
  const [opp, setOpp] = useState(id || null);
  const [songList, setSongList] = useState();
  const [text, setText] = useState();
  const [pending, setPending] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [apiError, setApiError] = useState('');
  const [errors, setErrors] = useState({});

  const selectedAccount = AppState.useState((s) => s.selectedAccount);

  const songs = getMySongs({ aac: selectedAccount });
  const myAccount = getMyAccount({
    artistaccountcode: selectedAccount,
  });
  const userInfo = getMyProfile();
  const createMutation = postSync();

  const history = useHistory();
  const { data: siteConfig } = useSiteConfigAuth();
	const noSyncs = siteConfig?.disable_syncs;
	useEffect(() => {
		if(noSyncs) {
			history.push('/');
		}
	}, [noSyncs])

  useEffect(() => {
    if (selectedAccount) {
      songs.refetch();
    }
  }, [selectedAccount]);
  // const syncs = getSyncs();
  const { data:syncsData, isSuccess } = useSyncsQuery(); 

  const checkErrors = () => {
    const errs = {};
    let valid = true;
    if (!opp) {
      errs.opp = t('regex:choose-sync-error');
      valid = false;
    }

    // has at least one performer
    if (!songList || songList.length < 1) {
      errs.songList = t('regex:add-at-least-one-song-error');
      valid = false;
    }

    if (songList) {
      songList.forEach((sl) => {
        if (!sl.workcode) {
          errs.songList = t('regex:select-every-song-error');
          valid = false;
        }
      });
    }

    setErrors(errs);
    return valid;
  };

  const submitApplication = () => {
    setPending(true);
    setApiError('');
    const valid = checkErrors();

    if (valid) {
      const selectedWorkcodes = songList.map((s) => s.workcode);
      const selectedSongs = songs.data.works.filter((w) => selectedWorkcodes.includes(w.workcode));

      const data = {
        type: 'sync',
        songs: JSON.stringify(selectedSongs),
        content: text,
        opportunity: (syncsData && opp) ? syncsData.find((sync) => parseInt(sync._id) === parseInt(opp))?.name : '',
        username: userInfo.data.username,
        email: userInfo.data.email,
        artist: myAccount.data.accountname,
      };

      createMutation.mutate(data, {
        onSuccess: () => {
          toast.success(t('other:successfully-submitted-sync-toast'), {
            position: 'bottom-right',
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          history.push('/syncs');
          setPending(false);
          sendEvent({ property: 'pe14489857_sync_brief_applied_for' });
        },
        onError: (error) => {
          setApiError(error.message);
          setPending(false);
        },
      });
    }
    setPending(false);
  };

  return (
    <>
      {reskinFlag ? (
        <>
          <div className="flex-1 xl:w-full bg-sentric-rebrand-light-grey min-h-50 lg:min-h-screen-minus-header order-last">
            <H2>{t('other:apply-for-sync')}</H2>
            <Spacer />
            {isSuccess
            && (
            <div className="w-full lg:w-2/3">
              <H4>{t('other:which-sync-header')}</H4>
              <Spacer thin />
              <Select
                list              
                id="selectSync"
                required
                className="select-search font-sentric-alt text-base"
                name="opp"
                placeholder={t('other:select-sync-placeholder')}
                value={opp}
                error={errors.opp}
                onChange={(selected) => setOpp(selected)}
                options={syncsData.map((sync) => ({ name: sync.name, value: sync._id }))}
              />
              <Spacer />
              <H4>{t('other:select-one-song-header')}</H4>
              <Spacer thin />
              <MultipleSelect
                id="txtSyncAddSong"
                type="text"
                addAnotherText={t('other:add-another-song')}
                placeholder={t('other:select-a-song-placeholder')}
                valueKey="workcode"
                value={songList}
                onBlur={() => {}}
                onChange={(arr) => {
                  setSongList(arr);
                }}
                error={errors.songList}
                options={songs.data?.works?.map((o) => ({ name: o.title, value: o.workcode }))}
              />
              <Spacer />
              <H4>{t('other:tell-us-more-header')}</H4>
              <Spacer thin />
              <TextArea
                id="txtSyncEvidence"
                className="w-full"
                type="textarea"
                error={errors.durationsecs}
                placeholder={t('other:supporting-text-placeholder')}
                value={text}
                onBlur={() => {}}
                onChange={(e) => {
                  setText(e.target.value);
                }}
              />
              <Spacer />
              <ApiErrorMessage apiError={apiError} />
              <div className="w-full flex justify-end">
                <RebrandPrimaryButton
                  id="btnSyncSubmit"
                  pending={pending}
                  onClick={submitApplication}
                  arrow
                >
                  {t('common:submit-button')}
                </RebrandPrimaryButton>
              </div>
              <Spacer />
            </div>
            )}
          </div>
        </>
      ) : (
        <>
          <div className="flex-1 xl:w-full bg-old-sentric-content-white min-h-50 lg:min-h-screen-minus-header order-last">
            <H2>{t('other:apply-for-sync')}</H2>
            <Spacer />
            {isSuccess
            && (
            <div className="w-full lg:w-2/3">
              <H4>{t('other:which-sync-header')}</H4>
              <Spacer thin />
              <Select
                id="selectSync"
                required
                className="w-full text-old-sentric-dark-gray"
                name="opp"
                placeholder={t('other:select-sync-placeholder')}
                value={opp}
                error={errors.opp}
                onChange={(selected) => setOpp(selected)}
                options={syncsData.map((sync) => ({ name: sync.name, value: sync._id }))}
              />
              <Spacer />
              <H4>{t('other:select-one-song-header')}</H4>
              <Spacer thin />
              <MultipleSelect
                id="txtSyncAddSong"
                type="text"
                addAnotherText={t('other:add-another-song')}
                placeholder={t('other:select-a-song-placeholder')}
                valueKey="workcode"
                value={songList}
                onBlur={() => {}}
                onChange={(arr) => {
                  setSongList(arr);
                }}
                error={errors.songList}
                options={songs.data?.works?.map((o) => ({ name: o.title, value: o.workcode }))}
              />
              <Spacer />
              <H4>{t('other:tell-us-more-header')}</H4>
              <Spacer thin />
              <TextArea
                id="txtSyncEvidence"
                className="w-full"
                type="textarea"
                error={errors.durationsecs}
                placeholder={t('other:supporting-text-placeholder')}
                value={text}
                onBlur={() => {}}
                onChange={(e) => {
                  setText(e.target.value);
                }}
              />
              <Spacer />
              <ApiErrorMessage apiError={apiError} />
              <ButtonInner
                id="btnSyncSubmit"
                disabled={pending}
                pending={pending}
                onClick={submitApplication}
              >
                {t('common:submit-button')}
              </ButtonInner>
              <Spacer />
            </div>
            )}
          </div>
        </>
      )}
    </>
  );
}
export default SyncsApply;